import { render, staticRenderFns } from "./ModalSignup.vue?vue&type=template&id=a0560152"
import script from "./ModalSignup.vue?vue&type=script&lang=js"
export * from "./ModalSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports